// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreProductCodes = (client) => ({
    /**
     * `GET /store/product-codes`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetProductCodes
     * @source packages/medusa-plugin-product-codes-v2/src/api/store/product-codes/route.ts
     */
    list: (query, headers) => client.fetch("/store/product-codes", { method: "GET", query, headers }),
});
//# sourceMappingURL=product-codes.js.map